/* Global basket drawer — see snippets/yt-cart-drawer.liquid.
 *
 * Rebuilt 9 Oct 2026 (Lucas: wrong product image, no "add ingredients"
 * section, "+ Build another blend" gone, match the new brand). Renders
 * /cart.js into the drawer markup; desktop slides from the right over a
 * dark overlay, phones get a full-page sheet (CSS transitions on .is-open).
 *
 * BUNDLE GROUPING (D16, docs/10-bundle-rearchitecture/05): lines whose
 * properties carry `_rc_bundle` are ONE blend — one card: the BASE line's
 * product image (the clean tin shot, slide 1 of the base product), the
 * blend's name, the plan line, "What's in it (N)" (the recipe, from the
 * formula when the lines carry `_yt_formula`), one whole-blend stepper and
 * one bin. Multiple bundles = multiple cards; plain lines render as cards
 * of their own.
 *
 * "ADD TO YOUR SCOOP" (per blend): the PDP's add-on cards, in the basket.
 * ADD puts the ingredient INTO that blend — the funnel's own machinery, as
 * yt-base-landing.js addToCart: POST /formula/submit (current recipe + the
 * new ingredient at its default dose) → GET /formula/:id/pdp (registered
 * bundle lines) → POST /cart/add.js (same plan, same tin count) → the old
 * bundle's lines go to 0 via /cart/update.js. Errors are an inline notice.
 *
 * Contract kept for the PDP scripts: [data-yt-cartdrawer], the `is-open`
 * class on it, [data-yt-cartdrawer-close], window.__ytCartDrawer
 * {open, close, render}. */
(function () {
  'use strict';
  var root = document.querySelector('[data-yt-cartdrawer]');
  if (!root) return;
  var PROXY = root.getAttribute('data-yt-proxy') || '/apps/yutrients';
  var ONE_TIME_MULT = 1.25;
  var BASIS_90 = 0.875;
  var MENU_SIZE = 8;
  var itemsEl = root.querySelector('[data-yt-cartdrawer-items]');
  var totalEl = root.querySelector('[data-yt-cartdrawer-total]');
  var shipEl = root.querySelector('[data-yt-cartdrawer-ship]');
  var FALLBACK_IMG = root.getAttribute('data-yt-fallback-img') || '';
  var BIN_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';

  function money(cents) { return '£' + (cents / 100).toFixed(2); }
  function gbp(n) { return '£' + (Math.round(Number(n) * 100) / 100).toFixed(2); }
  function round2(n) { return Math.round(n * 100) / 100; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function uuidv4() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  /** mg → display string in the ingredient's own unit (same rule as the PDP). */
  function doseDisplay(mg, unit) {
    if (String(unit || '').toLowerCase() === 'bn_cfu') return (Math.round(mg * 100) / 100) + ' bn CFU';
    if (unit === 'mcg' || (mg > 0 && mg < 1)) return Math.round(mg * 1000) + 'µg';
    var v = Math.round(mg * 100) / 100;
    if (v >= 1000 && v % 100 === 0) return (v / 1000) + 'g';
    return (Number.isInteger(v) ? v : v.toFixed(2)) + 'mg';
  }
  function thumb(src, size) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + (size || 240) + 'x$1$2');
  }
  function jsonHeaders(extra) {
    return Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, extra || {});
  }

  /* ── Free-shipping progress (founder 2026-09-05) ─────────────────────
   * Subscriptions ship free over the threshold (theme setting, in pence on
   * the data attribute); one-off orders pay the flat rate. */
  function isOfferLine(it) { return !!(it && it.properties && it.properties._yt_offer === 'ot30'); }
  function updateShip(cart) {
    if (!shipEl) return;
    var thr = Number(shipEl.getAttribute('data-threshold')) || 3000;
    var under = shipEl.getAttribute('data-under-rate') || '£4.95';
    var fill = shipEl.querySelector('[data-yt-cartdrawer-ship-fill]');
    var msg = shipEl.querySelector('[data-yt-cartdrawer-ship-msg]');
    var items = cart.items || [];
    // 21 Oct 2026: one-time 30-day offer lines (`_yt_offer: ot30`) count
    // towards the same £35 threshold at the price charged (final_line_price
    // is after the Function's discount) — Lucas: "free shipping is meant to
    // be £35". Unstamped one-off lines still pay the flat rate.
    var otMode = window.__ytOfferMode === 'one_time_30d';
    var subCents = items.reduce(function (s, it) { return (it.selling_plan_allocation || isOfferLine(it)) ? s + (it.final_line_price || 0) : s; }, 0);
    var hasSub = subCents > 0;
    if (otMode) {
      var pctO = hasSub ? Math.max(0, Math.min(100, Math.floor((subCents / thr) * 100))) : 0;
      if (fill) fill.style.width = pctO + '%';
      var unlockedO = hasSub && subCents >= thr;
      shipEl.classList.toggle('yt-cartdrawer__ship--unlocked', unlockedO);
      shipEl.classList.toggle('yt-cartdrawer__ship--onetime', items.length > 0 && !hasSub);
      if (!msg) return;
      var thrO = thr % 100 === 0 ? '£' + (thr / 100) : money(thr);
      if (!items.length) msg.textContent = 'Free UK shipping on orders over ' + thrO;
      else if (!hasSub) msg.textContent = 'One-off orders ship for ' + under + '.';
      else if (unlockedO) msg.textContent = "You've unlocked free UK shipping";
      else msg.textContent = 'Add ' + money(thr - subCents) + ' more for free UK shipping';
      return;
    }
    var pct = hasSub ? Math.max(0, Math.min(100, Math.floor((subCents / thr) * 100))) : 0;
    if (fill) fill.style.width = pct + '%';
    var unlocked = hasSub && subCents >= thr;
    shipEl.classList.toggle('yt-cartdrawer__ship--unlocked', unlocked);
    shipEl.classList.toggle('yt-cartdrawer__ship--onetime', items.length > 0 && !hasSub);
    if (!msg) return;
    var thrText = thr % 100 === 0 ? '£' + (thr / 100) : money(thr);
    if (!items.length) msg.textContent = 'Free UK shipping on subscription orders over ' + thrText;
    else if (!hasSub) msg.textContent = 'One-off orders ship for ' + under + '. Subscribe for free UK shipping over ' + thrText + '.';
    else if (unlocked) msg.textContent = "You've unlocked free UK shipping";
    else msg.textContent = 'Add ' + money(thr - subCents) + ' more to your subscription for free UK shipping';
  }

  /* ── Catalogue (5-minute cache) and ingredient photos ───────────────── */
  var catCache = { at: 0, promise: null };
  function catalogue() {
    if (catCache.promise && Date.now() - catCache.at < 5 * 60 * 1000) return catCache.promise;
    catCache.at = Date.now();
    catCache.promise = fetch(PROXY + '/catalogue', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { ingredients: [] }; })
      .then(function (d) { return d.ingredients || []; })
      .catch(function () { catCache.at = 0; return []; });
    return catCache.promise;
  }
  var basesCache = { at: 0, promise: null };
  function bases() {
    if (basesCache.promise && Date.now() - basesCache.at < 5 * 60 * 1000) return basesCache.promise;
    basesCache.at = Date.now();
    basesCache.promise = fetch(PROXY + '/bases', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { bases: [] }; })
      .then(function (d) { return d.bases || []; })
      .catch(function () { basesCache.at = 0; return []; });
    return basesCache.promise;
  }
  var photoPromises = new Map();
  function fetchProductImage(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return (p && (p.featured_image || (p.images && p.images[0]))) || null; })
      .catch(function () { return null; });
  }
  function photoSrc(slug) {
    var baked = window.__ytIngredientImages || {};
    if (baked[slug]) return Promise.resolve(baked[slug]);
    if (!photoPromises.has(slug)) {
      photoPromises.set(slug, fetchProductImage(slug).then(function (src) { return src || fetchProductImage('component-' + slug); }));
    }
    return photoPromises.get(slug);
  }

  /* ── Reading a blend from its cart lines ────────────────────────────── */
  function bundleKeyOf(item) { return (item.properties && item.properties._rc_bundle) || null; }
  function prop(lines, name) {
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].properties && lines[i].properties[name]) return lines[i].properties[name];
    }
    return null;
  }
  function isSpoon(item) {
    if (window.__ytSpoonVariantId && Number(item.variant_id) === Number(window.__ytSpoonVariantId)) return true;
    return /spoon/i.test(item.handle || '');
  }
  function baseHandle(item) { return String(item.handle || '').replace(/-90d$/, ''); }
  function baseLine(lines) {
    return lines.find(function (l) { return /^base-/.test(baseHandle(l)); }) || null;
  }
  /** '3mo' | '1mo' | 'onetime' — the 90-day twin set is its own products. */
  function planOf(lines) {
    if (lines.some(function (l) { return /-90d$/.test(l.handle || ''); })) return '3mo';
    if (lines.some(function (l) { return l.selling_plan_allocation; })) return '1mo';
    return 'onetime';
  }
  function basisMult(plan, lines) {
    // A one-time 30-day offer blend prices its add-ons at the sub basis too.
    if (plan === 'onetime' && lines && lines.some(isOfferLine)) return 1;
    return plan === 'onetime' ? ONE_TIME_MULT : plan === '3mo' ? BASIS_90 : 1;
  }
  function blendImage(lines) {
    var b = baseLine(lines);
    if (b && (b.image || b.featured_image)) return b.image || b.featured_image;
    var withImg = lines.find(function (l) { return !isSpoon(l) && (l.image || l.featured_image); });
    return withImg ? (withImg.image || withImg.featured_image) : FALLBACK_IMG;
  }
  function blendName(lines) {
    // The base's own product title is what the customer clicked and what
    // checkout shows; a custom blend goes by its tin name.
    var b = baseLine(lines);
    if (b && b.product_title) return b.product_title;
    return prop(lines, 'Tin name') || 'Your blend';
  }
  function blendQty(lines) { return lines.reduce(function (m, l) { return Math.max(m, l.quantity || 1); }, 1); }
  function blendTotal(lines) { return lines.reduce(function (s, l) { return s + (l.final_line_price || 0); }, 0); }
  function planLine(plan, totalCents, qty) {
    var each = qty > 1 ? ' (' + qty + ' tins)' : '';
    if (plan === '3mo') return '90-day plan · <b>' + money(totalCents) + '</b> every 90 days' + each;
    if (plan === '1mo') return '30-day subscription · <b>' + money(totalCents) + '</b>/mo' + each;
    if (plan === 'onetime' && window.__ytOfferMode === 'one_time_30d') return '30-day supply · <b>' + money(totalCents) + '</b>' + each;
    return 'One-time purchase' + each;
  }
  /** Parse a component variant title ("300 mg", "400 µg", "5 bn CFU") to mg. */
  function parseDoseMg(title) {
    var m = String(title || '').trim().match(/^([\d.]+)\s*(mg|g|mcg|µg|μg|ug|bn\s*cfu)$/i);
    if (!m) return null;
    var n = Number(m[1]); if (!isFinite(n) || n <= 0) return null;
    var u = m[2].toLowerCase().replace(/\s+/g, '');
    if (u === 'g') return n * 1000;
    if (u === 'mcg' || u === 'µg' || u === 'μg' || u === 'ug') return n / 1000;
    return n; // mg and bn_cfu (the catalogue stores billions in the mg field)
  }

  /* The blend's RECIPE, so the carousel knows what is already in it and
   * what to re-mint. New lines carry `_yt_formula` (9 Oct 2026) → GET
   * /formula/:id gives base_slug, add_ons and the full ingredient list.
   * Older carts carry only `_rc_bundle` (a key the /pdp route registers
   * fresh per view, so it cannot be looked up server-side); for those the
   * recipe is rebuilt from the lines themselves — base-<slug> + each
   * component-<slug> line's variant dose — and the carousel stays hidden
   * when a line cannot be read that way.
   *   { formula_id, base_slug, addOns: [{ingredient_id, amount_mg}],
   *     all: [{slug, name, amount_mg, unit}] } | null */
  var recipeCache = new Map(); // bundle key → promise
  function recipeFor(key, lines) {
    if (recipeCache.has(key)) return recipeCache.get(key);
    var p = (async function () {
      var fid = prop(lines, '_yt_formula');
      if (fid && /^[0-9a-f-]{36}$/i.test(fid)) {
        try {
          var r = await fetch(PROXY + '/formula/' + encodeURIComponent(fid), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (r.ok) {
            var f = await r.json();
            var all = (f.ingredients || []).map(function (i) { return { slug: i.slug, name: i.name, amount_mg: Number(i.amount_mg), unit: i.unit || 'mg', ingredient_id: i.ingredient_id }; });
            var addOns = f.base_slug
              ? (Array.isArray(f.add_ons) ? f.add_ons : [])
              : all;
            return {
              formula_id: f.id,
              base_slug: f.base_slug || null,
              addOns: addOns.filter(function (a) { return a.ingredient_id && Number(a.amount_mg) > 0; })
                .map(function (a) { return { ingredient_id: a.ingredient_id, amount_mg: Number(a.amount_mg) }; }),
              all: all,
            };
          }
        } catch (_e) { /* fall through to the lines */ }
      }
      var cat = await catalogue();
      var bySlug = new Map(cat.map(function (i) { return [i.slug, i]; }));
      var baseSlug = null, addOns2 = [], all2 = [];
      for (var i = 0; i < lines.length; i++) {
        var l = lines[i];
        if (isSpoon(l)) continue;
        var h = baseHandle(l);
        if (/^base-/.test(h)) { baseSlug = h.slice(5); continue; }
        if (!/^component-/.test(h)) continue;
        var ing = bySlug.get(h.slice(10));
        var mg = parseDoseMg(l.variant_title);
        if (!ing || mg == null) return null;
        addOns2.push({ ingredient_id: ing.id, amount_mg: mg });
        all2.push({ slug: ing.slug, name: ing.name, amount_mg: mg, unit: ing.unit || 'mg', ingredient_id: ing.id });
      }
      if (baseSlug) {
        var base = (await bases()).find(function (b) { return b.slug === baseSlug; });
        if (!base) return null;
        all2 = (base.ingredients || []).map(function (bi) {
          var c = bySlug.get(bi.slug);
          return { slug: bi.slug, name: bi.name, amount_mg: Number(bi.dose_mg), unit: (c && c.unit) || 'mg', ingredient_id: c ? c.id : null };
        }).concat(all2);
      }
      if (!baseSlug && !addOns2.length) return null;
      return { formula_id: null, base_slug: baseSlug, addOns: addOns2, all: all2 };
    })();
    recipeCache.set(key, p);
    return p;
  }

  /* ── Cart writes ────────────────────────────────────────────────────── */
  async function cartUpdate(updates) {
    var r = await fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify({ updates: updates }) });
    if (!r.ok) throw new Error('Something went wrong updating your basket — please try again.');
  }
  async function changeLine(key, quantity) {
    try { await cartUpdate((function () { var u = {}; u[key] = quantity; return u; })()); } catch (_e) {}
    await render();
  }
  /* Remove a whole bundle in ONE call so the blend never half-deletes. */
  async function removeBundle(lineKeys) {
    var updates = {};
    lineKeys.forEach(function (k) { updates[k] = 0; });
    try { await cartUpdate(updates); } catch (_e) {}
    await render();
  }
  /* Whole-blend quantity: one stepper scales EVERY line in the group. */
  async function setBundleQty(lines, n) {
    if (n <= 0) return removeBundle(lines.map(function (l) { return l.key; }));
    var updates = {};
    lines.forEach(function (l) { updates[l.key] = n; });
    try { await cartUpdate(updates); } catch (_e) {}
    await render();
  }

  /* ── Add an ingredient INTO a blend ─────────────────────────────────── */
  var busyKeys = new Set();
  var highlight = null; // { name } — bolded in "What's in it" on the next render
  var openInside = null; // the blend name whose list opens on the next render
  async function addToBlend(key, lines, recipe, ing) {
    var plan = planOf(lines);
    var qty = blendQty(lines);
    var ingredients = recipe.addOns.concat([{ ingredient_id: ing.id, amount_mg: Number(ing.default_dose_mg) }]);
    var body = {
      stack: { stack_name: (prop(lines, 'Tin name') || blendName(lines) || 'My Blend').slice(0, 60), primary_goals: [], ingredients: ingredients },
    };
    if (recipe.base_slug) body.base_slug = recipe.base_slug;
    if (recipe.formula_id) body.derived_from_formula_id = recipe.formula_id;
    // 1. Mint the formula: current recipe + the new ingredient.
    var submitRes = await fetch(PROXY + '/formula/submit', {
      method: 'POST', credentials: 'same-origin',
      headers: jsonHeaders({ 'Idempotency-Key': uuidv4() }),
      body: JSON.stringify(body),
    });
    if (!submitRes.ok) {
      var detail = 'Something went wrong — please try again.';
      try {
        var err = await submitRes.json();
        if (err && err.error) detail = (err.error.details && err.error.details.message_for_human) || err.error.message || detail;
      } catch (_e) {}
      throw new Error(detail);
    }
    var formulaId = (await submitRes.json()).formula_id;
    if (!formulaId) throw new Error('Something went wrong — please try again.');
    // 2. The registered bundle lines for every plan.
    var pdpRes = await fetch(PROXY + '/formula/' + encodeURIComponent(formulaId) + '/pdp', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!pdpRes.ok) throw new Error('Something went wrong preparing your blend — please try again.');
    var payload = await pdpRes.json();
    var bundle = payload.bundle;
    if (!bundle || !Array.isArray(bundle.items) || !bundle.items.length) throw new Error('Something went wrong preparing your blend — please try again.');
    // 3. Cart lines — identical mapping to the PDPs: 90-day twin set with
    //    its own key; one-time = 30-day set, plan-less, ':ot'.
    var has90 = !!(bundle.items_90d && bundle.items_90d.length && bundle.bundle_key_90d &&
      bundle.items_90d.every(function (i) { return i.variant_id; }) &&
      bundle.items_90d.some(function (i) { return i.selling_plan_90d; }));
    var isOneTime = plan === 'onetime';
    var is90Add = plan === '3mo' && has90;
    if (plan === '3mo' && !has90) throw new Error('Something went wrong preparing the 90-day plan — please try again.');
    var props = Object.assign({}, bundle.properties || {}, { _yt_formula: formulaId });
    if (is90Add) props._rc_bundle = bundle.bundle_key_90d;
    else if (isOneTime && props._rc_bundle) props._rc_bundle = props._rc_bundle + ':ot';
    // Re-minting a one-time 30-day offer blend keeps its stamp (21 Oct 2026).
    if (isOneTime && lines.some(isOfferLine)) props._yt_offer = 'ot30';
    var sourceItems = is90Add ? bundle.items_90d : bundle.items;
    // The free spoon is first-order only (9 Oct 2026) — and only if the
    // blend being replaced carried one (a signed-in repeat customer has none).
    var hadSpoon = lines.some(isSpoon);
    if (!hadSpoon || window.__ytRepeatCustomer === true) {
      sourceItems = sourceItems.filter(function (i) { return !(window.__ytSpoonVariantId && Number(i.variant_id) === Number(window.__ytSpoonVariantId)); });
    }
    var items = sourceItems.map(function (i) {
      var line = { id: Number(i.variant_id), quantity: (i.quantity || 1) * qty, properties: props };
      if (is90Add && i.selling_plan_90d) line.selling_plan = Number(i.selling_plan_90d);
      else if (!is90Add && !isOneTime && i.selling_plan_30d) line.selling_plan = Number(i.selling_plan_30d);
      return line;
    });
    // 4. Take the old set out FIRST, then add the new one. Proven 9 Oct
    //    2026: with the same base variant in the cart twice (old set + new
    //    set), Shopify's /cart/update.js matched the OLD line's key to the
    //    NEW line (same variant, first in the cart) and removed that one —
    //    the add-on landed as a second blend. Old and new must never
    //    coexist. If the add then fails, the old set goes straight back.
    var updates = {};
    lines.forEach(function (l) { updates[l.key] = 0; });
    await cartUpdate(updates);
    // Shopify PREPENDS — reversed keeps payload order (base first).
    var cartRes = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify({ items: items.slice().reverse() }) });
    if (!cartRes.ok) {
      var cdetail = 'Something went wrong adding to your blend — please try again.';
      try { var cerr = await cartRes.json(); if (cerr && (cerr.description || cerr.message)) cdetail = cerr.description || cerr.message; } catch (_e) {}
      var restore = lines.map(function (l) {
        var line = { id: Number(l.variant_id), quantity: l.quantity || 1, properties: l.properties || {} };
        if (l.selling_plan_allocation && l.selling_plan_allocation.selling_plan) line.selling_plan = Number(l.selling_plan_allocation.selling_plan.id);
        return line;
      });
      try { await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders(), body: JSON.stringify({ items: restore.reverse() }) }); } catch (_e) {}
      throw new Error(cdetail);
    }
    if (window.ytTrack) { try { ytTrack('basket_upsell_added', { base: recipe.base_slug, ingredient: ing.name, plan: plan }); } catch (_e) {} }
    highlight = { name: ing.name };
    openInside = blendName(lines);
  }

  /* ── Rendering ──────────────────────────────────────────────────────── */
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function insideList(rows, hl) {
    var list = el('ul', 'yt-cartdrawer__inside-list');
    rows.forEach(function (r) {
      var li = el('li', null, '<span>' + esc(r.name) + '</span><span>' + esc(r.dose) + '</span>');
      if (hl && r.name === hl.name) li.classList.add('is-new');
      list.appendChild(li);
    });
    return list;
  }
  function stepper(onMinus, onPlus, qty, labelA, labelB) {
    var q = el('div', 'yt-cartdrawer__qty');
    var minus = el('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', labelA);
    var num = el('span', null, esc(String(qty)));
    var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', labelB);
    minus.addEventListener('click', onMinus);
    plus.addEventListener('click', onPlus);
    q.appendChild(minus); q.appendChild(num); q.appendChild(plus);
    return q;
  }
  function binButton(onClick, label) {
    var b = el('button', 'yt-cartdrawer__bin', BIN_SVG + '<span>Remove</span>');
    b.type = 'button'; b.setAttribute('aria-label', label);
    b.addEventListener('click', onClick);
    return b;
  }

  function renderSingle(item) {
    var wrap = el('div', 'yt-cartdrawer__blend');
    var card = el('div', 'yt-cartdrawer__card');
    var top = el('div', 'yt-cartdrawer__card-top');
    var img = el('img', 'yt-cartdrawer__img'); img.alt = '';
    img.src = thumb(item.image || item.featured_image) || FALLBACK_IMG;
    var body = el('div', 'yt-cartdrawer__body');
    var v = item.variant_title || '';
    var m = v.match(/^(.*) · YCF-[A-Z0-9]+(-90)?$/);
    var name = m ? m[1] : (item.product_title || v);
    body.appendChild(el('p', 'yt-cartdrawer__name', esc(name)));
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var sub = plan ? esc(plan.name) : (isOfferLine(item) ? '30-day supply' : 'One-time purchase');
    if (!m && v && v !== 'Default Title') sub = esc(v) + ' · ' + sub;
    body.appendChild(el('p', 'yt-cartdrawer__plan', sub));
    top.appendChild(img); top.appendChild(body);
    top.appendChild(el('span', 'yt-cartdrawer__price', money(item.final_line_price)));
    card.appendChild(top);
    var ctl = el('div', 'yt-cartdrawer__ctl');
    ctl.appendChild(stepper(function () { changeLine(item.key, item.quantity - 1); }, function () { changeLine(item.key, item.quantity + 1); }, item.quantity, 'Decrease quantity', 'Increase quantity'));
    ctl.appendChild(binButton(function () { changeLine(item.key, 0); }, 'Remove from basket'));
    card.appendChild(ctl);
    wrap.appendChild(card);
    return wrap;
  }

  function renderBlend(key, lines) {
    var wrap = el('div', 'yt-cartdrawer__blend');
    var card = el('div', 'yt-cartdrawer__card');
    var top = el('div', 'yt-cartdrawer__card-top');
    var img = el('img', 'yt-cartdrawer__img'); img.alt = '';
    img.src = thumb(blendImage(lines)) || FALLBACK_IMG;
    var body = el('div', 'yt-cartdrawer__body');
    var name = blendName(lines);
    var plan = planOf(lines);
    var qty = blendQty(lines);
    body.appendChild(el('p', 'yt-cartdrawer__name', esc(name)));
    body.appendChild(el('p', 'yt-cartdrawer__plan', planLine(plan, blendTotal(lines), qty)));
    // "What's in it (N)" — the lines first (every ingredient line is a
    // real row), the full recipe once it resolves (a base's own
    // ingredients are not cart lines).
    var inside = el('details', 'yt-cartdrawer__inside');
    var lineRows = lines.filter(function (l) { return !isSpoon(l) && !/^base-/.test(baseHandle(l)); }).map(function (l) {
      var dose = l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
      return { name: l.product_title || '', dose: dose };
    });
    var b = baseLine(lines);
    if (b) lineRows.unshift({ name: (b.product_title || 'Base') + ' base', dose: '' });
    var hl = highlight; // captured now — render() clears it before the recipe resolves
    var sum = el('summary', 'yt-cartdrawer__inside-sum', '<span>What\'s in it (' + lineRows.length + ')</span>');
    inside.appendChild(sum);
    inside.appendChild(insideList(lineRows, hl));
    if (openInside && openInside === name) { inside.open = true; openInside = null; }
    body.appendChild(inside);
    top.appendChild(img); top.appendChild(body);
    top.appendChild(el('span', 'yt-cartdrawer__price', money(blendTotal(lines))));
    card.appendChild(top);
    var ctl = el('div', 'yt-cartdrawer__ctl');
    ctl.appendChild(stepper(function () { setBundleQty(lines, qty - 1); }, function () { setBundleQty(lines, qty + 1); }, qty, 'One fewer of this blend', 'One more of this blend'));
    ctl.appendChild(binButton(function () { removeBundle(lines.map(function (l) { return l.key; })); }, 'Remove blend from basket'));
    card.appendChild(ctl);
    wrap.appendChild(card);

    // "Add to your scoop" — filled once the recipe and catalogue resolve.
    var scoop = el('section', 'yt-cartdrawer__scoop');
    scoop.hidden = true;
    scoop.innerHTML = '<div class="yt-cartdrawer__scoop-head"><h3 class="yt-cartdrawer__scoop-title">Add to your scoop</h3><p class="yt-cartdrawer__scoop-sub">Goes into this blend</p></div>' +
      '<p class="yt-cartdrawer__notice" role="alert" hidden></p><div class="yt-cartdrawer__row"></div>';
    wrap.appendChild(scoop);
    var notice = scoop.querySelector('.yt-cartdrawer__notice');
    var row = scoop.querySelector('.yt-cartdrawer__row');
    Promise.all([recipeFor(key, lines), catalogue()]).then(function (res) {
      var recipe = res[0], cat = res[1];
      if (!recipe || !cat.length || !wrap.isConnected) return;
      // The full recipe → "What's in it (9)".
      if (recipe.all && recipe.all.length) {
        sum.innerHTML = '<span>What\'s in it (' + recipe.all.length + ')</span>';
        var old = inside.querySelector('.yt-cartdrawer__inside-list');
        if (old) old.remove();
        inside.appendChild(insideList(recipe.all.map(function (r) { return { name: r.name, dose: doseDisplay(Number(r.amount_mg), r.unit) }; }), hl));
      }
      var inBlend = new Set(recipe.all.map(function (r) { return r.slug; }));
      var inIds = new Set(recipe.addOns.map(function (a) { return a.ingredient_id; }));
      var menu = cat.filter(function (i) {
        return i.raw_cost_per_mg != null && Number(i.default_dose_mg) > 0 && !inBlend.has(i.slug) && !inIds.has(i.id);
      }).sort(function (a, b) {
        var ra = a.popularity_rank == null ? 1e9 : a.popularity_rank;
        var rb = b.popularity_rank == null ? 1e9 : b.popularity_rank;
        return ra - rb;
      }).slice(0, MENU_SIZE);
      if (!menu.length) return;
      row.innerHTML = menu.map(function (ing) {
        var perMonth = round2((Number(ing.price_fee || 0) + Number(ing.price_multiple || 0) * Number(ing.raw_cost_per_mg) * Number(ing.default_dose_mg)) * basisMult(plan, lines));
        return '<div class="yt-cartdrawer__add" data-yt-scoop-card="' + esc(ing.id) + '">' +
          '<img class="yt-cartdrawer__add-img" alt="' + esc(ing.name) + '" loading="lazy">' +
          '<span class="yt-cartdrawer__add-price">+' + gbp(perMonth) + (plan === 'onetime' ? '' : '/mo') + '</span>' +
          '<div class="yt-cartdrawer__add-body"><span class="yt-cartdrawer__add-name">' + esc(ing.name) + '</span>' +
          '<span class="yt-cartdrawer__add-dose">' + esc(doseDisplay(Number(ing.default_dose_mg), ing.unit)) + ' daily</span>' +
          '<button type="button" class="yt-cartdrawer__add-btn" data-yt-scoop-add>ADD</button></div></div>';
      }).join('');
      scoop.hidden = false;
      // 30 Oct 2026: prev/next arrows — a desktop mouse had no way to reach the cards past the third.
      var nav = el('div', 'yt-cartdrawer__scoop-nav');
      var pv = el('button', null, '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'); pv.type = 'button'; pv.setAttribute('aria-label', 'Previous add-ons');
      var nx = el('button', null, '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'); nx.type = 'button'; nx.setAttribute('aria-label', 'More add-ons');
      nav.appendChild(pv); nav.appendChild(nx); scoop.appendChild(nav);
      function stepW() { var c = row.firstElementChild; return c ? c.getBoundingClientRect().width + 10 : 120; }
      function paintNav() { var max = row.scrollWidth - row.clientWidth; nav.hidden = max <= 2; pv.disabled = row.scrollLeft <= 1; nx.disabled = row.scrollLeft >= max - 1; }
      pv.addEventListener('click', function () { row.scrollBy({ left: -stepW(), behavior: 'smooth' }); });
      nx.addEventListener('click', function () { row.scrollBy({ left: stepW(), behavior: 'smooth' }); });
      row.addEventListener('scroll', function () { clearTimeout(row._ytNavT); row._ytNavT = setTimeout(paintNav, 60); }, { passive: true });
      requestAnimationFrame(paintNav); setTimeout(paintNav, 500);
      row.querySelectorAll('[data-yt-scoop-card]').forEach(function (cardEl) {
        var ing = menu.find(function (i) { return i.id === cardEl.getAttribute('data-yt-scoop-card'); });
        if (!ing) return;
        photoSrc(ing.slug).then(function (src) { if (src) cardEl.querySelector('img').src = src; });
        var btn = cardEl.querySelector('[data-yt-scoop-add]');
        btn.addEventListener('click', async function () {
          if (busyKeys.has(key)) return;
          busyKeys.add(key);
          notice.hidden = true;
          cardEl.classList.add('is-adding');
          btn.disabled = true; btn.textContent = 'ADDING…';
          row.classList.add('is-busy');
          try {
            await addToBlend(key, lines, recipe, ing);
            busyKeys.delete(key);
            await render();
          } catch (e) {
            busyKeys.delete(key);
            row.classList.remove('is-busy');
            cardEl.classList.remove('is-adding');
            btn.disabled = false; btn.textContent = 'ADD';
            notice.textContent = (e && e.message) || 'Something went wrong — please try again.';
            notice.hidden = false;
          }
        });
      });
    }).catch(function () { /* the card stands without a carousel */ });
    return wrap;
  }

  function syncHeaderCount(cart) {
    document.querySelectorAll('.yt-header__action--cart').forEach(function (a) {
      // 30 Oct 2026: free gift lines (the £0 weighing spoon) don't count — the header said "2" after adding one blend.
      var n = (cart.items || []).reduce(function (s, i) { var gift = Number(i.final_line_price) === 0 && /weighing spoon/i.test(i.product_title || i.title || ''); return s + (gift ? 0 : (i.quantity || 0)); }, 0);
      var badge = a.querySelector('.yt-header__cart-count');
      if (n > 0) {
        if (!badge) { badge = el('span', 'yt-header__cart-count'); badge.setAttribute('aria-hidden', 'true'); a.appendChild(badge); }
        badge.textContent = String(n);
      } else if (badge) badge.remove();
      a.setAttribute('aria-label', 'Basket, ' + n + ' items');
    });
  }

  var rendering = null;
  function render() {
    if (rendering) return rendering;
    rendering = (async function () {
      var cart;
      try {
        cart = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      } catch (e) { return; }
      if (totalEl) totalEl.textContent = money(cart.total_price);
      updateShip(cart);
      syncHeaderCount(cart);
      itemsEl.textContent = '';
      root.classList.remove('is-pending');
      root.classList.toggle('is-empty', !cart.items.length);
      if (!cart.items.length) {
        var empty = el('div', 'yt-cartdrawer__empty', '<p>Your basket is empty</p><a class="yt-cartdrawer__empty-cta" href="/pages/shop-all">Shop by goal</a>');
        itemsEl.appendChild(empty);
        highlight = null; openInside = null;
        return;
      }
      /* Group bundle lines by _rc_bundle in first-seen cart order. */
      var groups = {};
      var sequence = [];
      cart.items.forEach(function (item) {
        var key = bundleKeyOf(item);
        if (key) {
          if (!groups[key]) { groups[key] = []; sequence.push({ kind: 'bundle', key: key }); }
          groups[key].push(item);
        } else {
          sequence.push({ kind: 'single', item: item });
        }
      });
      sequence.forEach(function (entry) {
        itemsEl.appendChild(entry.kind === 'bundle' ? renderBlend(entry.key, groups[entry.key]) : renderSingle(entry.item));
      });
      highlight = null; openInside = null;
    })();
    return rendering.finally(function () { rendering = null; });
  }

  function show() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function open() {
    // 14 Oct 2026: render and show first; the duplicate-gift tidy (12 Oct)
    // runs behind the open basket and re-renders only if it removed a line.
    // It used to sit on the critical path: one more cart read before anyone
    // saw anything.
    return render().then(function () {
      show();
      if (window.ytTrack) { try { ytTrack('basket_opened', {}); } catch (_e) {} }
      var tidy = (window.ytDedupeGifts ? window.ytDedupeGifts() : Promise.resolve(false));
      return tidy.then(function (changed) { if (changed) return render(); }).catch(function () {});
    });
  }
  /* 14 Oct 2026: the basket opens the moment Add is pressed, with the blend
   * pencilled in, and fills in when the add completes (open() replaces it).
   * The product page knows the name and price before any server answers. */
  function openPending(info) {
    if (root.classList.contains('is-open')) return;
    var card = el('div', 'yt-cartdrawer__pending',
      '<div class="yt-cartdrawer__pending-row"><span class="yt-cartdrawer__pending-dot" aria-hidden="true"></span>' +
      '<div><p class="yt-cartdrawer__pending-name"></p><p class="yt-cartdrawer__pending-sub">Adding to your basket…</p></div>' +
      '<p class="yt-cartdrawer__pending-price"></p></div>');
    card.querySelector('.yt-cartdrawer__pending-name').textContent = (info && info.name) || 'Your blend';
    card.querySelector('.yt-cartdrawer__pending-price').textContent = (info && info.price) || '';
    itemsEl.insertBefore(card, itemsEl.firstChild);
    root.classList.remove('is-empty');
    root.classList.add('is-pending');
    show();
  }
  function cancelPending() {
    root.classList.remove('is-pending');
    var card = itemsEl.querySelector('.yt-cartdrawer__pending');
    if (card) card.remove();
    if (!itemsEl.children.length) close();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  root.querySelectorAll('[data-yt-cartdrawer-close]').forEach(function (e) { e.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });
  /* Header basket icon (any page): open the drawer in place. The href
   * stays /cart for no-JS and as the natural fallback. */
  document.querySelectorAll('.yt-header__action--cart, a[href="/cart"]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });

  window.__ytCartDrawer = { open: open, close: close, render: render, openPending: openPending, cancelPending: cancelPending };

  /* 14 Oct 2026: on a product page, warm the catalogue and bases while the
   * visitor is still reading, so the basket has them before Add is pressed. */
  if (document.querySelector('[data-yt-base-add], .yt-formula-pdp__cta, [data-yt-quick-add]')) {
    setTimeout(function () { try { catalogue(); bases(); } catch (_e) {} }, 1200);
  }
})();
